import React, { useCallback, useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Link, useRouteMatch } from 'react-router-dom'
import block from 'bem-cn'

import { LocaleCommonKeysType } from 'shared/locale/en-US'
import { useMediaDevice, useModalContext } from '@bcraft-frontend-lib/core'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'

import { addNotify } from 'components/Notify'

import { INavigationItem } from '../data'

import './NavigationItem.scss'

const b = block('navigation-header__item')

const NavigationItem: React.FC<INavigationItem> = props => {
  const {
    route,
    mobileRoute,
    text,
    icon,
    isAuthReq = false,
    isNew = false,
    modalRoute,
    isTopGame = false,
    isModalForMobile = false,
    subItems,
  } = props
  const { pathname, search } = useLocation()
  const isMobile = useMediaDevice({ query: 'maxTablet' })
  const { pushNewModal } = useModalContext()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).common
  const localeSlots = useSelector(selectLocaleDict, shallowEqual).slots

  const onClickNavItem = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (!isAuth && isAuthReq) {
        e.preventDefault()
        addNotify(localeSlots.pleaseAuth)
      }

      if (modalRoute && (!isModalForMobile || (isMobile && isModalForMobile))) {
        e.preventDefault()
        pushNewModal(modalRoute)()
      }
    },
    [isAuth, isAuthReq, localeSlots, pushNewModal, isMobile, modalRoute, isModalForMobile],
  )

  const isActive = pathname === route

  return (
    <Link
      className={b({ active: isActive })}
      to={isMobile && mobileRoute ? mobileRoute : route}
      onClick={onClickNavItem}>
      <div className={b('inner')}>
        <div className={b('info')}>
          {isTopGame ? <span className={b('info-text', { top: true })}>{localeSlots.top}</span> : null}
          {isNew ? <span className={b('info-text', { new: true })}>{localeSlots.new}</span> : null}
        </div>

        <span> {locale[text as LocaleCommonKeysType] || text}</span>
      </div>
    </Link>
  )
}

export default NavigationItem
